import React from 'react';
import PropTypes from 'prop-types';
import NavBarItem from './NavBarItem';
import {Message} from '@aperza/ui';
import type AppConfig from '../domain/AppConfig';
import AppService from '../service/AppService';
import WebMediaQuery from './WebMediaQuery';
const appConfig:AppConfig = AppService.appConfig();

export default class SignUpLink extends React.Component {

  static propTypes = {
    viewer: PropTypes.shape({
      disableMarketplaceBanner: PropTypes.bool,
    }),
  };

  render() {

    let signUpUrl = `https://id${appConfig.baseComDomain}/signup/register.html`;
    if (appConfig.isAperzaMarketplace  || !this.props.disableMarketplaceBanner) {
      signUpUrl = `https://order${appConfig.baseComDomain}/member/index.html`;
    }

    return (
      <WebMediaQuery largeDesktopOnly={true}>
        <NavBarItem title={<Message messageId="navbar.signUp" />}
                    icon="signup"
                    className="sign-up"
                    url={signUpUrl}
        />
      </WebMediaQuery>
    )
  }

}
